














































































































































    import Vue from 'vue';
    import SettingsService from '../../settings.service'

    const settingsService = new SettingsService()

    export default Vue.extend({
        props: ['settings'],
        data() {
            return {
                domains: [],
                chooseDomains: 'general',
            }
        },
        created() {
            this.getDomains()
        },
        computed: {},
        methods: {
            getDomains() {
                settingsService.getDomains((domains: any) => {
                    this.domains = domains
                })
            },
            hasSettings(domain: string) {
                const then = this;
                let isEmpty = ['counter', 'open', 'send', 'error', 'smart_button_click', 'smart_button_send'].reduce(
                    function (isEmpty, target) {
                        return (
                            isEmpty
                            && !then.settings.yandex[domain][target]
                        );
                    },
                    true
                );
                isEmpty = isEmpty && ['open', 'send', 'error', 'smart_button_click', 'smart_button_send'].reduce(
                    function (isEmpty, target) {
                        return (
                            isEmpty
                            && !then.settings.google[domain][target].category
                            && !then.settings.google[domain][target].action
                        );
                    },
                    true
                );

                return !isEmpty;
            }
        }
    });



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/analytics/Analytics.vue